import { useEffect } from 'react';
import { useSnapshot } from 'valtio';

import Link from '@cartwhl/common/components/Link';
import { ProjectType } from '@cartwhl/common/types';
import { getHomepageUrl, getStudioUrl } from '@cartwhl/common/utils';
import ProjectCard from '@cartwhl/ui/feature/ProjectCard';
import Button from '@cartwhl/ui/input/Button';
import EmptyState from '@cartwhl/ui/messaging/EmptyState';

import { userStore } from 'stores/global';

import CurrentPlan from './CurrentPlan';
import ProfileSection from './ProfileSection';

export default function Overview() {
  const { downloadHistory } = useSnapshot(userStore.state);

  useEffect(() => {
    if (downloadHistory.status === 'initial') {
      userStore.fetchDownloadHistory({ limit: 6, sortAscending: false });
    }
  }, [downloadHistory.status]);

  return (
    <div className="overview max-w-(--breakpoint-md) mx-auto">
      <ProfileSection title="Your plan" boxed={false} className="mt-8">
        <CurrentPlan />
      </ProfileSection>

      <ProfileSection
        title="Recent downloads"
        boxed={false}
        className="mt-8"
        actions={
          <Link href={getHomepageUrl('/profile/download-history')}>
            <Button variant="tertiary">View All</Button>
          </Link>
        }
      >
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:px-0">
          {downloadHistory.data && downloadHistory.data.items.length > 0 ? (
            <>
              {downloadHistory.data.items.map((item) => (
                <ProjectCard
                  key={item.projectID}
                  title={item.projectName}
                  type={
                    item.projectType === ProjectType.MOTION ? 'animate' : 'pose'
                  }
                  href={`${getStudioUrl()}${
                    item.projectType === ProjectType.MOTION
                      ? `/motion/${item.projectID}`
                      : `/pose/${item.projectID}`
                  }
                  `}
                  preview={item.mp4Path}
                  lastUpdatedAt={item.dateRequested}
                />
              ))}
            </>
          ) : (
            <EmptyState
              className="col-span-full"
              description="No downloads found"
            />
          )}
        </div>
      </ProfileSection>
    </div>
  );
}
